import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import Tag from '@sharedComponents/Tag';
import Typography from '@sharedComponents/Typography';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';

import * as selectStyle from '../InputSelect/style.module.css';
import * as style from './style.module.css';

const InputMultiSelectList = ({
    control,
    name = '',
    options = [],
    required = false,
    isError = false,
    placeholder,
    isSearchable = true,
}) => {
    const { t } = useTranslation();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={[]}
            rules={{
                validate: (value) => {
                    if (required && (!value || value.length === 0)) {
                        return t('This field is required');
                    }
                    return true;
                },
            }}
            render={({ field }) => (
                <Select
                    {...field}
                    unstyled
                    isMulti
                    isSearchable={isSearchable}
                    menuIsOpen={isSearchable ? undefined : false}
                    maxMenuHeight={200}
                    placeholder={placeholder}
                    options={options}
                    classNames={{
                        menu: () => selectStyle.menu,
                        control: (state) => {
                            if (isError) return style.controlError;
                            return state.menuIsOpen ? style.controlOpen : style.control;
                        },
                        menuList: () => selectStyle.menuList,
                        option: () => selectStyle.option,
                        valueContainer: () => style.valueContainer,
                        indicatorsContainer: () => style.indicatorsContainer,
                    }}
                    onChange={(selected) => field.onChange(selected ?? [])}
                    components={{
                        MultiValue: (props) => (
                            <components.MultiValue {...props}>
                                <Tag onClick={props.removeProps.onClick} color="selected" icon={faXmark}>
                                    {props.data.label}
                                </Tag>
                            </components.MultiValue>
                        ),
                        MultiValueRemove: () => null,
                        DropdownIndicator: isSearchable ? components.DropdownIndicator : null,
                        NoOptionsMessage: (props) => (
                            <components.NoOptionsMessage {...props}>
                                <Typography color={'neutral-tertiary'} center>
                                    {t('No options available')}
                                </Typography>
                            </components.NoOptionsMessage>
                        ),
                    }}
                />
            )}
        />
    );
};

InputMultiSelectList.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.string })),
    required: PropTypes.bool,
    isError: PropTypes.bool,
    placeholder: PropTypes.string,
    isSearchable: PropTypes.bool,
    maxItems: PropTypes.number,
};

export default InputMultiSelectList;
